<template>
  <BootstrapModal class="add-image-type"
    v-on="$listeners"
    
    @save="saveImageType"
  >
    <div>
      <div class="img-wrapper d-flex justify-content-center mb-2">
        <img
          :src="src"
    
          width="auto"
          height="150"
        />
      </div>
      

      <FormSelect v-model="type"
        class="form-element"
        id="size"
        label="Beeldtype"

        :options="options"
      />
    </div>

    <template #title>
      {{ "Afbeeldingstype opslaan" }}
    </template>
  </BootstrapModal>
</template>

<script>

import FormInput from "src/components/Inputs/FormInput.vue"
import BootstrapModal from "../BootstrapModal.vue"
import FormSelect from "/src/components/Inputs/FormSelect.vue"

export default {
  components: {
    FormInput,
    BootstrapModal,
    FormSelect,
  },
  props: {
    callback: {
      type: Function,
      required: false,
    },
    options: {
      type: Array,
      required: false,
    },
    file: {
      type: [String, File],
      required: false,
    },
  },
  data() {
    return {
      type: "",
    }
  },
  methods: {
    saveImageType() {
      this.callback(this.type)
      this.$emit("close")
    },
  },
  computed: {
    src() {
      const file = this.file
      if (file && typeof file !== "string") {
        return URL.createObjectURL(file)
      }
      return file
    },
  },
}

</script>

<style scoped>

.add-image-type {
  flex-basis: 400px;
}

.img-wrapper, img {
  border-radius: 1px;
}

.img-wrapper {
  background-color: #f9f9f9;
}

</style>
